export default __webpack_public_path__ + "static/banner-media-release-aug6-199510f58872480ff1716181854602aa.jpg";